export default __webpack_public_path__ + "static/media/podno.e22f383e.jpeg";